<div class="jumbotron text-center">
  <div class="container">
    <div class="row">
      <div class="col-sm-6" style="text-align:left">
        <button type="button" class="btn btn-outline-primary" (click)="open(content)">Add New Salary</button>
        <a class="btn btn-outline-success mx-3" [routerLink]="['/advance_salary']">Advance Salary</a>
      </div>
      <div class="col-sm-6">
        <div class="input-group" dir="auto">
          <button type="button" class="btn btn-outline-success" (click)="clearFilter()">Refresh
          </button>
          <input type="month" class="form-control" style="padding: 0px;" (change)="filterDate()"
            [(ngModel)]="filter_date" id="date">
        </div>
      </div>
    </div>
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th>#</th>
                <th>Month</th>
                <th>Employee</th>
                <th>Basic Salary</th>
                <th>Actual Working Days</th>
                <th>Net SALARY</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (list_length == 0) {
                <tr>
                  <td colspan="7">No data found</td>
                </tr>
              }
              @for (item of items; track item; let i = $index) {
                <tr>
                  <td>{{ i+1 }}</td>
                  <td>{{ item.salary.created_at | date:'MMMM yyyy' }}</td>
                  <td>{{getEmployeeInfo(item.salary.employee_id)?.name}}</td>
                  <td>{{ item.salary.contract_salary }}</td>
                  <td>{{ item.salary.work_days }}</td>
                  <td style="background-color:aliceblue;">
                    <span style="cursor: pointer; color: blue;" (click)="open(salary_content)">{{
                    item.salary.paid_salary }}</span>
                    <ng-template #salary_content let-modal>
                      <div class="modal-header">
                        <h4 class="modal-title" id="modal-basic-title">Other details
                        </h4>
                        <button type="button" class="close" aria-label="Close"
                          (click)="modal.dismiss('Cross click')">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="mb-3">
                          <div class="row">
                            <div class="col">
                              <div class="card border-secondary">
                                <div class="card-header">
                                  <b>{{ getEmployeeInfo(item.salary.employee_id)?.name }}</b>
                                </div>
                                <div class="card-body">
                                  <ul class="list-group list-group-flush text-secondary">
                                    <li class="list-group-item">Advance
                                      <span class="float-end">{{item.salary.advance |
                                      number:'1.3-3'}}</span>
                                    </li>
                                    <li class="list-group-item">Hold<span
                                      class="float-end">{{item.salary.hold |
                                    number:'1.3-3'}}</span>
                                  </li>
                                  <li class="list-group-item">Reward
                                    <span class="float-end">{{item.salary.reward |
                                    number:'1.3-3'}}</span>
                                  </li>
                                  <li class="list-group-item">Deduction
                                    <span class="float-end">{{item.salary.deduction |
                                    number:'1.3-3'}}</span>
                                  </li>
                                  <li class="list-group-item">Deduction Reason
                                    <span
                                    class="float-end">{{item.salary.deduction_reason}}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline-dark" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">Ok</button>
                    </div>
                  </ng-template>
                </td>
                <td>
                  <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                    dir="auto">
                    <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-danger"
                      (click)="onDelete(item.salary.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                      </svg>
                    </button>
                    <button type="button" class="btn btn-secondary"
                      (click)="edit(content2, item.salary)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
            <tr>
              <td colspan="5"></td>
              <td style="background-color:aliceblue;">{{ total_main_salary | number:'1.3-3' }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-8 col-lg-9" style="text-align:left">
        <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="10" [rotate]="true"
        [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">New Employee Salary</h4>

    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="employee_id" class="form-label">Employee</label>
      <select class="form-select" [(ngModel)]="item.employee_id" id="employee_id" (change)="onEmployeeSelected()">
        <option value="0">-- SELECT --</option>
        @for (employee of employees; track employee) {
          <option [value]='employee.id'>{{ employee.name }}</option>
        }
      </select>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="contract_salary" class="form-label">Basic Salary</label>
          <input type="number" class="form-control" id="contract_salary" [(ngModel)]="item.contract_salary"
            disabled>
        </div>
        <div class="col">
          <label for="advance_salary" class="form-label">Advance Salary</label>
          <input type="number" class="form-control" id="advance_salary" [(ngModel)]="item.advance_salary"
            disabled>
        </div>
        <div class="col">
          <label for="work_days" class="form-label">Act. Duty Days</label>
          <input type="number" class="form-control" [(ngModel)]="item.work_days" id="work_days" max="30"
            min="0">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="reward" class="form-label">Reward <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="item.reward" id="reward">
        </div>
        <div class="col">
          <label for="deduction" class="form-label">Deduction <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="item.deduction" id="deduction">
        </div>
        <div class="col">
          <label for="hold" class="form-label">Hold <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="item.hold" id="hold">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="deduction_reason" class="form-label">Deduction Reason</label>
      <textarea class="form-control" [(ngModel)]="item.deduction_reason" id="deduction_reason" rows="2"
      cols="50"></textarea>
    </div>
    <div class="mb-3">
      <label for="notes" class="form-label">Notes</label>
      <textarea class="form-control" [(ngModel)]="item.notes" id="notes" rows="2" cols="50"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add</button>
  </div>
</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Salary</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="employee_id" class="form-label">Employee</label>
      <select class="form-select" [(ngModel)]="new_item.employee_id" id="employee_id" disabled>
        <option>-- SELECT --</option>
        @for (employee of employees; track employee) {
          <option [value]='employee.id'>{{ employee.name }}</option>
        }
      </select>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="contract_salary" class="form-label">Basic Salary</label>
          <input type="number" class="form-control" id="contract_salary" [(ngModel)]="new_item.contract_salary"
            disabled>
        </div>
        <div class="col">
          <label for="advance_salary" class="form-label">Advance Salary</label>
          <input type="number" class="form-control" id="advance_salary" [(ngModel)]="new_item.advance_salary"
            disabled>
        </div>
        <div class="col">
          <label for="work_days" class="form-label">Act. Duty Days</label>
          <input type="number" class="form-control" [(ngModel)]="new_item.work_days" id="work_days" max="30"
            min="0">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="reward" class="form-label">Reward <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="new_item.reward" id="reward">
        </div>
        <div class="col">
          <label for="deduction" class="form-label">Deduction <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="new_item.deduction" id="deduction">
        </div>
        <div class="col">
          <label for="hold" class="form-label">Hold <small>(OMR)</small></label>
          <input type="number" class="form-control" [(ngModel)]="new_item.hold" id="hold">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="deduction_reason" class="form-label">Deduction Reason</label>
      <textarea class="form-control" [(ngModel)]="new_item.deduction_reason" id="deduction_reason" rows="2"
      cols="50"></textarea>
    </div>
    <div class="mb-3">
      <label for="notes" class="form-label">Notes</label>
      <textarea class="form-control" [(ngModel)]="new_item.notes" id="notes" rows="2" cols="50"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(new_item_id)">Update
    </button>
  </div>
</ng-template>